export default __webpack_public_path__ + "static/media/info-purple.bbd62099.svg";